import { getOrderStatusIcon } from '@Utils/orderStatusIcons';

export const groupInventory = () => {
  return [
    {
      name: 'Nhập kho',
      icon: getOrderStatusIcon('requestConfirmation'),
      iconActive: getOrderStatusIcon('requestConfirmation'),
      color: '#785BBC',
      childId: [7, 8],
      child: [],
    },
    {
      name: 'In và đóng gói',
      icon: getOrderStatusIcon('packed'),
      iconActive: getOrderStatusIcon('packed'),
      color: '#52A49A',
      childId: [9, 10, 11, 23],
      child: [],
    },
    // {
    //   name: 'Vận chuyển',
    //   icon: getOrderStatusIcon('ordering'),
    //   iconActive: getOrderStatusIcon('ordering'),
    //   color: '#4CAABE',
    //   childId: [12, 13, 14],
    //   child: [],
    // },
    {
      name: 'Cần xử lý',
      icon: getOrderStatusIcon('needsAction'),
      iconActive: getOrderStatusIcon('needsAction'),
      color: '#4896EC',
      childId: [17, 19, 20, 18],
      child: [],
    },
  ];
};

export const getInventoryDetail = (type) => {
  if (!type) {
    return {};
  }
  const objectType = {
    export: {
      name: 'Xuất kho',
      type: ['export', 'manual_export'],
      urlBack: '/reports/inventory-receipt?type=export',
    },
    import: {
      name: 'Nhập kho',
      type: ['import', 'manual_import'],
      urlBack: '/reports/inventory-receipt?type=import',
    },
    manual_import: { name: 'Nhập kho', urlBack: '/reports/inventory-receipt?type=import' },
    manual_export: { name: 'Xuất kho', urlBack: '/reports/inventory-receipt?type=export' },
    inventory_adjust: {
      name: 'Bù trừ kiểm kho',
      type: ['inventory_adjust'],
      urlBack: '/reports/inventory-receipt?type=inventory_adjust',
    },
  };
  return objectType[type];
};
